/* eslint-disable react/button-has-type */
import React, { useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { actions as productCatalogActions } from '../../../store/ducks/product-catalog.duck';
import { ReactComponent as Menu } from '../../../../_metronic/layout/assets/layout-svg-icons/menu4.svg';
import { ReactComponent as MenuActive } from '../../../../_metronic/layout/assets/layout-svg-icons/menu_active4.svg';
import { IAppState } from '../../../store/rootDuck';
import DialogCategories from '../DialogCategories';
import { toAbsoluteUrl } from '../../../../_metronic';

const HeaderMobileNavigation = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down(540));
  const { catalogCategories } = useSelector((store: IAppState) => ({
    catalogCategories: store.categories.catalogCategories,
  }));

  const { filter } = useSelector((store: IAppState) => ({
    filter: store.productsCatalog.filter,
  }));
  const [open, setOpen] = useState(false);
  const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(null);

  // useLayoutEffect(() => {
  //   dispatch(categoriesActions.fetchCatalogCategories({with_products: false}));
  // }, []);

  const clear = () => {
    resetProducts();
    setSelectedCategoryId(null);
  };

  const resetProducts = useCallback(() => {
    dispatch(productCatalogActions.fetchRequest({ page: 1, perPage: 24, filter }));
  }, [catalogCategories]);

  return (
    <div style={{ width: '100%', justifyContent: 'space-between', }}>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <div style={{ cursor: 'pointer' }} onClick={() => setOpen(true)}>
          {open ? <MenuActive /> : <Menu />}
        </div>
        {!isSmallScreen && (
          <Link to='/products/catalog' style={{ marginLeft: 20 }}>
            <img alt='logo' src={toAbsoluteUrl('/media/logos/logo-opt1.png')} height={40} />
          </Link>
        )}
          <div style={{height: 35, paddingLeft: 10}}>
              <a href="tel:88002010350">
                  <p
                      style={{
                          padding: 0,
                          margin: 0,
                          fontSize: 12,
                          color: '#d01c1f',
                          fontWeight: 'bold'
                      }}
                  >
                      8 800 201 03 50
                  </p>
              </a>
              <a href="tel:89649652828">
                  <p
                      style={{
                          padding: 0,
                          margin: 0,
                          fontSize: 12,
                          color: '#d01c1f',
                          fontWeight: 'bold'
                      }}
                  >
                      8 964 965 28 28
                  </p>
              </a>
          </div>

      </div>
        <DialogCategories
        setSelectedCategoryId={setSelectedCategoryId}
        selectedCategoryId={selectedCategoryId}
        open={open}
        close={() => setOpen(false)}
        clear={clear}
        setSearch={value => dispatch(productCatalogActions.setSearch(value))}
      />
    </div>
  );
};

export default HeaderMobileNavigation;
